import styles from './RequestedTherapist.module.css'
import CheckSquareIcon from '../Icons/CheckSquareIcon'
// import RoomIcon from '../Icons/RoomIcon'
import RequestedRoomIcon from '../../Assets/images/room.svg'

export const RequestedRoom = ({ compact = false }) => {
  return (
    <div className={styles.requestedRoom}>
        {!compact && <CheckSquareIcon/>}
        {/* <RoomIcon/> */}
        <img src={RequestedRoomIcon} alt="icon" />
        Requested Room
    </div>
  )
}
